import mitt from "mitt";

export type ControlEventArgs = {
  [ControlEvent.LiveStarted]: {
    startDate: Date;
  };
  [ControlEvent.HistoryStarted]: {
    startDate: Date;
    endDate: Date;
  };
  [ControlEvent.VideoDisabled]: undefined;
  [ControlEvent.CameraChanged]: {
    cameraId: number;
  };
  [ControlEvent.VideoEnabled]: {
    startDate: Date;
    endDate: Date | null;
    seekValue?: number;
    isLive?: boolean;
  };
  [ControlEvent.ZoomChanged]: {
    zoomLevel: number;
  };
  [ControlEvent.TimeChanged]: {
    currentTime: number;
  };
};

export const emitter = mitt<ControlEventArgs>();
export const playbackEmitter = mitt();

export enum ControlEvent {
  LiveStarted = "LIVE_STARTED",
  HistoryStarted = "HISTORY_STARTED",
  VideoEnabled = "VIDEO_ENABLED",
  VideoDisabled = "VIDEO_DISABLED",
  CameraChanged = "CAMERA_CHANGED",
  ZoomChanged = "ZOOM_CHANGED",
  TimeChanged = "TIME_CHANGED",
}
